// Word lists for the memorable password generator (helpers/passwordPolicy
// generateMemorablePassword): adjective + noun + two digits, e.g. "bluetote42"
// or "zielonykot17". Lowercase ASCII only (a handle-style password an
// operative can type on a Zebra keyboard without a layer switch), 3–8
// letters each so two words + 2 digits land between 9 and 18 characters.
// Polish adjectives and nouns are both masculine so they agree, and are
// written without diacritics.

export const EN_ADJECTIVES: readonly string[] = [
    "blue", "green", "red", "gold", "silver", "amber", "coral", "ivory", "olive", "violet",
    "bright", "quick", "calm", "warm", "cool", "happy", "lucky", "brave", "quiet", "sunny",
    "rainy", "fresh", "sweet", "soft", "bold", "tiny", "giant", "swift", "clever", "gentle",
    "wild", "early", "round", "square", "smooth", "sharp", "shiny", "misty", "frosty", "windy",
    "dusty", "sandy", "rocky", "mossy", "leafy", "royal", "humble", "merry", "jolly", "witty",
    "nimble", "steady", "sturdy", "cosy", "snug", "zesty", "crisp", "mellow", "plucky", "spry",
    "handy", "hardy", "keen", "lively", "neat", "proud", "rapid", "rustic", "silent", "solid",
    "sturdy", "sunny", "tidy", "upbeat", "vivid", "wise", "young", "zippy", "breezy", "cheery",
    "dandy", "eager", "fancy", "grand", "honest", "jaunty", "kindly", "loyal", "mighty", "noble",
];

export const EN_NOUNS: readonly string[] = [
    "tote", "box", "crate", "pallet", "shelf", "label", "scanner", "trolley", "cage", "forklift",
    "carton", "parcel", "ribbon", "kettle", "teapot", "biscuit", "apple", "lemon", "mango", "cherry",
    "pepper", "carrot", "pumpkin", "walnut", "maple", "cedar", "willow", "river", "harbour", "island",
    "meadow", "valley", "canyon", "summit", "lantern", "compass", "anchor", "rocket", "planet", "comet",
    "falcon", "badger", "otter", "rabbit", "tiger", "panda", "dolphin", "penguin", "puffin", "heron",
    "robin", "sparrow", "hammer", "wrench", "pencil", "marker", "button", "pocket", "jacket", "helmet",
    "saddle", "wagon", "engine", "piston", "cable", "magnet", "crystal", "marble", "pebble", "beacon",
    "bridge", "castle", "garden", "orchard", "window", "ladder", "basket", "bucket", "barrel", "candle",
    "feather", "glove", "kite", "melon", "noodle", "orange", "paddle", "quilt", "rooster", "saucer",
    "tunnel", "violin", "waffle", "yacht", "zebra", "acorn", "bagel", "cactus", "dragon", "eagle",
    "fiddle", "goose", "hazel", "igloo", "jigsaw", "koala", "llama", "mitten", "nugget", "oyster",
];

export const PL_ADJECTIVES: readonly string[] = [
    "zielony", "szybki", "maly", "duzy", "nowy", "stary", "cieply", "zimny", "jasny", "ciemny",
    "dobry", "mily", "wesoly", "cichy", "glosny", "mocny", "lekki", "ciezki", "slodki", "czysty",
    "suchy", "mokry", "twardy", "miekki", "prosty", "dlugi", "krotki", "szeroki", "wysoki", "niski",
    "bialy", "czarny", "zolty", "modry", "szary", "zloty", "srebrny", "rudy", "siwy", "bury",
    "sprytny", "dzielny", "madry", "zwinny", "spokojny", "wiosenny", "letni", "zimowy", "polny",
    "lesny", "morski", "gorski", "rzeczny", "wiejski", "miejski", "rowny", "okragly", "gladki", "ostry",
    "swiezy", "mlody", "dobry", "chytry", "bystry", "rzeski", "zdrowy", "dumny", "wierny", "sowity",
];

export const PL_NOUNS: readonly string[] = [
    "kot", "pies", "dom", "las", "most", "stol", "wozek", "karton", "regal", "worek",
    "klucz", "kubek", "zegar", "rower", "autobus", "pociag", "statek", "samolot", "kamien", "kwiat",
    "ogrod", "ptak", "lis", "wilk", "zajac", "bocian", "tygrys", "zolw", "delfin", "rekin",
    "chleb", "ser", "sok", "cukier", "pieprz", "obiad", "talerz", "widelec", "garnek", "czajnik",
    "komputer", "telefon", "ekran", "dlugopis", "zeszyt", "plecak", "but", "kapelusz", "szalik", "plaszcz",
    "sweter", "koc", "fotel", "dywan", "obraz", "parasol", "latawiec", "balon", "piasek", "kamyk",
    "wiatr", "deszcz", "snieg", "ksiezyc", "sad", "park", "rynek", "zamek", "ogrodnik",
    "jablko", "cytryn", "banan", "orzech", "klon", "dab", "wierzba", "potok", "port", "wyspa",
    "lacznik", "kompas", "kotwica", "rakieta", "planeta", "sokol", "borsuk", "krolik", "pingwin", "wrobel",
    "mlotek", "klucznik", "olowek", "guzik", "kieszen", "kask", "siodlo", "silnik", "kabel", "magnes",
];

export const wordListsFor = (language: string): { adjectives: readonly string[]; nouns: readonly string[] } =>
    (language === "pl"
        ? { adjectives: PL_ADJECTIVES, nouns: PL_NOUNS }
        : { adjectives: EN_ADJECTIVES, nouns: EN_NOUNS });
